import Vue from 'vue'
import store from '@/store'
import vuexI18n from 'vuex-i18n'
import { getDefaultLang } from '@/util/consts'

Vue.use(vuexI18n.plugin, store)

// add translations directly to the application
Vue.i18n.add('uk', require('./uk.json'))
Vue.i18n.add('ru', require('./ru.json'))
Vue.i18n.add('en', require('./en.json'))
Vue.i18n.add('pl', require('./pl.json'))
Vue.i18n.add('nl', require('./nl.json'))
Vue.i18n.add('de', require('./de.json'))
Vue.i18n.add('fr', require('./fr.json'))
Vue.i18n.add('it', require('./it.json'))
Vue.i18n.add('ro', require('./ro.json'))
Vue.i18n.add('us', require('./us.json'))
Vue.i18n.add('et', require('./et.json'))
Vue.i18n.add('es', require('./es.json'))
Vue.i18n.add('el', require('./el.json'))
Vue.i18n.add('es-us', require('./es-us.json'))

// set the start locale to use
const lang = getDefaultLang()
Vue.i18n.set(lang)

// set fallback for non-translated strings
Vue.i18n.fallback('en')
